import script from "./CompleteProfileBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./CompleteProfileBtn.vue?vue&type=script&setup=true&lang=js"

import "./CompleteProfileBtn.vue?vue&type=style&index=0&id=30b455c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30b455c8"]])

export default __exports__